import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "../Component/Sidebar";
import { UserContex } from "../context API/UserContext";
import edit from "./../images/pencil.png";
import delet from "./../images/delete.png";
const MangePortifolio = ({ logout }) => {
  const [company, setCompany] = useState([]);
  const [project, setProject] = useState([]);
  const [userData, setUserData] = useContext(UserContex);
  const navigate = useNavigate();
  useEffect(() => {
    axios
      .get("https://back.waratechnology.com/api/portifolio/getcompany")
      .then((res) => {
        setCompany(res.data.data);
        console.log(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  useEffect(() => {
    axios
      .get("https://back.waratechnology.com/api/portifolio/getproject")
      .then((res) => {
        setProject(res.data.data);
        console.log(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const handledelete = async(id) => {
    await axios
      .delete("https://back.waratechnology.com/api/portifolio/delcompany/" + id)
      .then((res) => console.log(res.data))
      .catch((err) => alert(err.response.data.msg));
    window.location.reload();
  };
  const handledeletep = async(id) => {
    console.log(id);
   await axios
      .delete("https://back.waratechnology.com/api/portifolio/delproject/" + id)
      .then((res) => console.log(res.data))
      .catch((err) => alert(err.response.data.msg));
    window.location.reload();
  };
  useEffect(() => {
    if (!userData.user) {
      navigate("/login");
    }
  });
  return (
    <div className="flex ">
      <Sidebar logout={logout} />
      <div className="container mx-auto p-4 ml-80">
        <h1 className="text-3xl font-bold mb-4">Portifolio</h1>
        <div className="flex justify-between">
          <Link
            to="/addcompany"
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full"
          >
            Add New Company
          </Link>
          <Link
            to="/addproject"
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full"
          >
            Add New Project
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-3  ">
          <div className="mt-4 overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="border-collapse border border-slate-500 bg-gray-200">
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                  >
                    Company Name
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                  >
                    logo
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {company.map((data, index) => (
                  <tr>
                    <td className="px-6 py-3 text-left text-xs font-medium text-gray-900  tracking-wider border border-slate-700">
                      {data.name}
                    </td>
                    <td className="px-1 py-1 text-left text-xs font-medium text-gray-900  tracking-wider border border-slate-700">
                      <img
                        className="h-24"
                        src={"https://back.waratechnology.com" + data.image}
                      />
                    </td>
                    <td className="flex justify-between items-center gap-1 px-3 py-8 text-center text-xs font-medium text-gray-900 tracking-wider border border-l-0 border-t-0 border-slate-700">
                      <Link className="mr-4 py-2 text-white px-3 border-none">
                        <img className="w-7" src={edit} alt="" />
                      </Link>
                      <img
                        onClick={(e) => handledelete(data.id)}
                        className="w-7 cursor-pointer"
                        src={delet}
                        alt=""
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="mt-4 overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="border-collapse border border-slate-500 bg-gray-200">
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                  >
                    project Name
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                  >
                    Type
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                  >
                    URL
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                  >
                    Image
                  </th>
                  <th
                    scope="col"
                    className="px-1 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {project.map((data, index) => (
                  <tr>
                    <td className="px-6 py-3 text-left text-xs font-medium text-gray-900  tracking-wider border border-slate-700">
                      {data.name}
                    </td>
                    <td className="px-6 py-3 text-left text-xs font-medium text-gray-900  tracking-wider border border-slate-700">
                      {data.project_type}
                    </td>
                    <td className="px-6 py-3 text-left text-xs font-medium text-gray-900  tracking-wider border border-slate-700">
                      <Link to={`${data.url}`}>{data.url}</Link>
                    </td>
                    <td className="px-6 py-3 text-left text-xs font-medium text-gray-900  tracking-wider border border-slate-700">
                      <img
                        className="h-24 "
                        src={"https://back.waratechnology.com" + data.image}
                      />
                    </td>
                    <td className="flex justify-between items-center gap-1 px-3 py-10 text-center text-xs font-medium text-gray-900 tracking-wider border border-t-0 border-l-0 border-slate-700 ">
                      <Link
                        to={`/updateproject/${data.id}`}
                        className="mr-4 py-2 text-white px-3 border rounded-full"
                      >
                        <img className="w-7" src={edit} alt="" />
                      </Link>

                      <img onClick={()=>handledeletep(data.id)} className="w-7 cursor-pointer" src={delet} alt="" />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MangePortifolio;
